@if (quiz(); as item) {
  <main class="knowledge-check-page">
    <div class="knowledge-check-topbar">
      <a class="ghost-button as-link" [routerLink]="['/learning']">← Zurück zum Lernbereich</a>
      <span class="kicker">Modul {{ item.enrollment.moduleNumber }} · {{ item.enrollment.courseTitle }}</span>
    </div>

    @if (!item.passed) {
      <section class="knowledge-check-hero">
        <span class="kicker">Abschließende Prüfung</span>
        <h1>Abschluss-Wissens-Check</h1>
        <p>{{ item.title }} · {{ item.description }}</p>
        <div class="knowledge-check-progress-row">
          <span>Frage {{ currentQuestionIndex() + 1 }} von {{ item.questions.length }}</span>
          <span>Bestehen ab {{ item.passPercentage }} % · {{ answeredCount(item.questions) }} beantwortet</span>
        </div>
        <div class="progress-track"><div class="progress-fill" [style.width.%]="item.questions.length ? (currentQuestionIndex() + 1) / item.questions.length * 100 : 0"></div></div>
      </section>
    }

    @if (item.passed) {
      <section class="final-exam-success-dialog" role="dialog" aria-labelledby="final-exam-success-title">
        <div class="final-exam-success-icon" aria-hidden="true">✓</div>
        <span class="kicker">Abschlussprüfung bestanden</span>
        <h2 id="final-exam-success-title">Herzlichen Glückwunsch!</h2>
        <p>
          Du hast die Abschlussprüfung für <strong>{{ item.enrollment.courseTitle }}</strong>
          mit {{ result()?.scorePercent ?? item.scorePercent }} % bestanden.
        </p>
        <p>Dein Modul ist abgeschlossen und dein Zertifikat wurde ausgestellt.</p>

        <div class="final-exam-success-actions">
          @if (item.certificateId) {
            <a class="primary-button as-link justify-center" [routerLink]="['/certificates', item.certificateId]">
              Zertifikat ansehen
            </a>
          } @else {
            <a class="primary-button as-link justify-center" routerLink="/certificates">
              Zu meinen Zertifikaten
            </a>
          }
          <a class="ghost-button as-link justify-center" routerLink="/learning">
            Zurück zum Lernbereich
          </a>
        </div>
      </section>
    } @else if (!item.available) {
      <section class="knowledge-check-card">
        <h2>Prüfung noch nicht freigeschaltet</h2>
        <p>Schließe zuerst alle Lektionen einschließlich der verpflichtenden Lektions-Wissens-Checks ab. Diese Abschlussprüfung ist ebenfalls verpflichtend.</p>
      </section>
    } @else if (item.questions.length) {
      <section class="knowledge-check-card">
        @if (currentQuestion(item.questions); as question) {
          <article class="knowledge-question">
            <div class="knowledge-question-number">Prüfungsfrage {{ currentQuestionIndex() + 1 }} von {{ item.questions.length }}</div>
            <h2>{{ question.text }}</h2>
            <div class="knowledge-options">
              @for (option of question.options; track option.id; let optionIndex = $index) {
                <label class="knowledge-option" [class.selected]="selectedOptionId(question.id) === option.id">
                  <input type="radio" [name]="'final-question-' + question.id" [checked]="selectedOptionId(question.id) === option.id" (change)="selectOption(question.id, option.id)">
                  <span class="knowledge-option-letter">{{ ['A', 'B', 'C', 'D'][optionIndex] }}</span>
                  <span>{{ option.text }}</span>
                </label>
              }
            </div>
          </article>
        }
      </section>

      @if (error()) { <p class="field-error">{{ error() }}</p> }
      @if (result(); as resultItem) { <div class="info-message">{{ resultItem.message }} Ergebnis: {{ resultItem.scorePercent }} %</div> }
      <div class="knowledge-check-actions">
        <a class="ghost-button as-link" [routerLink]="['/learning']">Später fortsetzen</a>
        <div class="knowledge-check-step-actions">
          <button class="ghost-button" type="button" (click)="goToPreviousQuestion()" [disabled]="currentQuestionIndex() === 0 || saving()">Zurück</button>
          @if (isLastQuestion(item.questions)) {
            <button class="primary-button" type="button" (click)="submitQuiz(item)" [disabled]="saving() || item.passed">Abschluss-Wissens-Check auswerten</button>
          } @else {
            <button class="primary-button" type="button" (click)="goToNextQuestion(item)" [disabled]="saving()">Nächste Frage</button>
          }
        </div>
      </div>
    } @else {
      <section class="knowledge-check-card"><p>Für diesen Kurs sind keine Abschlussfragen hinterlegt.</p></section>
    }
  </main>
} @else { <div class="empty">Abschluss-Wissens-Check wird geladen.</div> }
